import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import dashboardService from "services/DashboardService";
import Loading from "components/Common/Loading";
import GuidelineCard from "./GuidelineCard";
import "./dashboard.css";

const Dashboard = (props) => {
	document.title = "Senda | Dashboard";

	const [guidelines, setGuidelines] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [hasCompany, setHasCompany] = useState(true);

	useEffect(() => {
		// Verificar se tem empresa selecionada
		const companyId = localStorage.getItem("company_id");
		
		if (!companyId || companyId === "null") {
			setHasCompany(false);
			return;
		}

		setHasCompany(true);
		getAll();
	}, []);

	// Listener para mudança de empresa
	useEffect(() => {
		const handleCompanyChange = () => {
			const companyId = localStorage.getItem("company_id");
			
			if (!companyId || companyId === "null") {
				setHasCompany(false);
				setGuidelines([]);
			} else {
				setHasCompany(true);
				getAll();
			}
		};

		window.addEventListener('companyChanged', handleCompanyChange);
		
		return () => {
			window.removeEventListener('companyChanged', handleCompanyChange);
		};
	}, []);

	const getCompanyGuidelines = async () => {
		try {
			setGuidelines(await dashboardService.getCompanyGuidelines());
		} catch (e) {
			console.log(e);
		}
	};

	const getAll = async () => {
		setIsLoading(true);
		await getCompanyGuidelines();
		setIsLoading(false);
	};

	// Se não tem empresa selecionada, mostrar tela vazia
	if (!hasCompany) {
		return (
			<React.Fragment>
				<div className="page-content" style={{ 
					display: 'flex', 
					alignItems: 'center', 
					justifyContent: 'center',
					minHeight: '80vh'
				}}>
					<Container fluid>
						<div style={{ 
							textAlign: 'center',
							color: '#74788d',
							fontSize: '18px'
						}}>
							<i className="bx bx-buildings" style={{ 
								fontSize: '64px', 
								display: 'block',
								marginBottom: '20px',
								opacity: 0.5
							}}></i>
							<p>Selecione a empresa que deseja acessar</p>
							<small style={{ fontSize: '14px', opacity: 0.7, display: 'block', marginTop: '10px' }}>
								Use o seletor no canto superior direito
							</small>
						</div>
					</Container>
				</div>
			</React.Fragment>
		);
	}

	// Renderização normal quando tem empresa
	return (
		<React.Fragment>
			<Loading isLoading={isLoading}>
				<div className="page-content">
					<Breadcrumbs title={props.t("Dashboard")} />
					<Container fluid>
						{guidelines && (
							<div className="guidelines-container">
								{guidelines.map((guideline, index) => (
									<GuidelineCard
										key={index}
										name={guideline.name}
										description={guideline.description}
									/>
								))}
							</div>
						)}
					</Container>
				</div>
			</Loading>
		</React.Fragment>
	);
};

export default withTranslation()(Dashboard);
